import { Outlet } from "react-router-dom";

const Products = () => <Outlet />;

export default Products;
